"use client";

import "@/style/css/SideBar.css";
import { MenuProps, SideDrawer } from "@/layout/Navbar/Side/SideDrawer";
import { mainBantuanNavMenus } from "@/layout/Navbar/Side/Sub/SubBantuan";
import { mainKoleksiNavMenus } from "@/layout/Navbar/Side/Sub/SubKoleksi";
import { mainFasiliasNavMenus } from "@/layout/Navbar/Side/Sub/SubFasilitas";
import { mainLayananNavMenus } from "@/layout/Navbar/Side/Sub/SubLayanan";
import { mainTentangKamiNavMenus } from "@/layout/Navbar/Side/Sub/SubTentangKami";

const mainNavMenus: MenuProps[] = [
  {
    title: "Beranda",
    path: "/"
  },
  {
    title: "Tentang Kami",
    anchor: "subSideBarTentangKami"
  },
  {
    title: "Koleksi",
    path: "/koleksi"
  },
  {
    title: "Layanan",
    anchor: "subSideBarLayanan"
  },
  {
    title: "Bantuan",
    anchor: "subSideBarBantuan"
  }
];

const UserNavbarSide = () => {
  return (
    <>
      <SideDrawer title="Menu" anchor="mainSideBar" menus={mainNavMenus}/>
      <SideDrawer title="Bantuan" anchor="subSideBarBantuan" prevAnchor="mainSideBar" menus={mainBantuanNavMenus}/>
      <SideDrawer title="Fasilitas" anchor="listItemFasilitas" prevAnchor="subSideBarTentangKami"
                  menus={mainFasiliasNavMenus}/>
      <SideDrawer title="Koleksi" anchor="subSideBarKoleksi" prevAnchor="mainSideBar" menus={mainKoleksiNavMenus}/>
      <SideDrawer title="Layanan" anchor="subSideBarLayanan" prevAnchor="mainSideBar"
                  menus={mainLayananNavMenus}/>
      <SideDrawer title="Tentang Kami" anchor="subSideBarTentangKami" prevAnchor="mainSideBar"
                  menus={mainTentangKamiNavMenus}/>
    </>

  );
};

export default UserNavbarSide;
